/*global google*/
import React from "react";
import ReactDOM from "react-dom";
import { compose, withProps, withStateHandlers } from "recompose";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap
} from "react-google-maps";
import { MarkerWithLabel } from "react-google-maps/lib/components/addons/MarkerWithLabel";

const getCoordinates = (x) => {
  if (x !== undefined) {
    let lastChar = x.charAt(x.length-1);
    let newCoords = parseFloat(x.slice(0, -1));
    if (lastChar === 'W' || lastChar === 'S') {
      return (-newCoords);
    }
  
    else {
      return newCoords;
    }
  }
}

const chooseIcon = (storm) => {
  let stormClass = storm.stormclass.slice(5, 6);
  if (stormClass < 5) {
    return 'https://s3.us-east-2.amazonaws.com/dsw-icons/icons/ts.png';
  }
  else if (stormClass >= 5 && stormClass < 6) {
    return 'https://s3.us-east-2.amazonaws.com/dsw-icons/icons/small.png';
  }
  else {
    return 'https://s3.us-east-2.amazonaws.com/dsw-icons/icons/large64.png';
  } 
}

const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

const Map = compose(
  withStateHandlers(() => ({
    isOpen: false,
  }), {
    onToggleOpen: ({ isOpen }) => () => ({
      isOpen: !isOpen,
    })
  }),
  withProps({
    googleMapURL:
      "https://maps.googleapis.com/maps/api/js?key=AIzaSyAK4RiRaTxiurMr-pZ9_PJpRYjXdot6y-Q&v=3.exp&libraries=geometry,drawing,places",
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `300px` }} />,
    mapElement: <div style={{ height: `100%` }} />
  }),
  withScriptjs,
  withGoogleMap
)(props => {
  if (props) {
    const makeMarkers = (storms) => {
      let stormArray = [];
      for (let storm in storms) {
          let name = capitalizeFirstLetter(storms[storm].stormname.toString().toLowerCase());
          let key = storms[storm].timestamp;
          let lat = getCoordinates(storms[storm].stormlat);
          let lng = getCoordinates(storms[storm].stormlong);
          let marker = (<MarkerWithLabel key={key} position={{ lat: lat, lng: lng}} icon={chooseIcon(storms[storm])} 
          labelAnchor={new google.maps.Point(0, 0)}
          labelStyle={{fontSize: "2em", padding: "2px"}}
          >
          <div>{name}</div>
          </MarkerWithLabel>);
          stormArray.push(marker);    
      }
      return stormArray;
    }
    return (
      <GoogleMap defaultZoom={4} center={{ lat: props.coords.lat, lng: props.coords.long }}>
       {makeMarkers(props.uniques)}
      </GoogleMap>
      )
  }
    
  }
);

ReactDOM.render(<Map />, document.getElementById("root"));
export default Map;


// WEBPACK FOOTER //
// ./src/components/Map.js